import React, { useEffect, useRef, useState } from "react";
import "./stylesDragAndDropTable.css";

import cashIcon from "../../../../assets/images/cash.png";
import coinIcon from "../../../../assets/images/coins.png";
import freeCashIcon from "../../../../assets/images/free-cash.png";

import Sortable from "sortablejs";
import { Empty, message, Popover } from "antd";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import { NAVIGATION_ROUTES } from "../../../../utils/NavigationUtils";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import { useSelector } from "react-redux";

const handleCCF = (text) => {
  if (text === 0 || text === null) return "";
  if (text >= 0.0 && text <= 0.49) return "red";
  if (text >= 0.5 && text <= 0.99) return "yellow";
  if (text === 1) return "";
  if (text > 1) return "green";
  return "";
};

const DragAndDropTable = ({ columns = [], data = [], mode = "resize", expandAllRows = false }) => {

  const { appConfig } = useSelector((state) => state.config);
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );

  const tableRef = useRef(null);
  const theadRef = useRef(null);

  const [columnsState, setColumnsState] = useState(columns);
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    if (expandAllRows) {
      setExpandedRows(data.map((row) => row.customId));
    } else {
      setExpandedRows([]);
    }
  }, [expandAllRows, data]);

  const popoverContent = (record) => {
    return (
      <div className="betsReport-popover-content">
        <>
          <div className="betsReport-popover-content-header">
            <p>{AppStrings.USER_ID}:</p>
            <p>{record.userId}</p>
          </div>
          <div className="betsReport-popover-content-body">
            <div className="betsReport-popover-content-body-item">
              <p className="betsReport-popover-content-body-item-label">CCF:</p>
              <p className="betsReport-popover-content-body-item-value">
                {Intl.NumberFormat("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(record.ccf)}
              </p>
            </div>
            <div className="betsReport-popover-content-body-item">
              <p className="betsReport-popover-content-body-item-label">
                {AppStrings.TOTAL_STAKE}:
              </p>
              <p className="betsReport-popover-content-body-item-value">
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: appConfig?.app_currency_config?.default_currency,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(record?.user_metadata?.total_wagers)}
              </p>
            </div>
            <div className="betsReport-popover-content-body-item">
              <p className="betsReport-popover-content-body-item-label">{AppStrings.P_L}:</p>
              <p className="betsReport-popover-content-body-item-value">
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: appConfig?.app_currency_config?.default_currency,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(record?.user_metadata?.net_pnl)}
              </p>
            </div>
            <div className="betsReport-popover-content-body-item">
              <p className="betsReport-popover-content-body-item-label">
                {AppStrings.MARGIN}:
              </p>
              <p className="betsReport-popover-content-body-item-value">
                {record?.user_metadata?.net_pnl < 0 ? "-" : ""}
                {record?.user_metadata?.margin_percentage}%
              </p>
            </div>
          </div>
        </>
      </div>
    );
  };

  const getUserData = async (user_id) => {
    const params = {
      search_by: "user_id",
      search_str: user_id,
    };

    try {
      const response = await PrivateAdminPanelInstance?.get(
        API_ROUTES?.SEARCH_USER + "user_id:" + user_id,
        params
      );
      const userData = response?.data?.data;
      return userData;
    } catch (error) {
      console.log("Error fetching user data", error);
    }
  };

  const handleViewUserClicked = async (user_data) => {
    const userData = await getUserData(user_data.userId);

    localStorage.setItem("selected_user_data", JSON.stringify(userData));
    localStorage.setItem("wallet_active", "false");

    const url = `${NAVIGATION_ROUTES?.USER_MANAGER}?userId=${user_data.userId}&tab=BETS`;
    window.open(url, "_blank");
  };

  const copyToClipboard = (row) => {
    navigator.clipboard.writeText(row.id);
    message.success(AppStrings.PAM_BET_ID_COPIED_TO_CLIPBOARD);
  };

  const renderMap = {
    provider: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth, textTransform: "capitalize" }}
      >
        <div className="bets-report-provider-container">
          <div className="bets-report-expand-icon-container">
            {(row.league.length > 1 ||
              row.sport.length > 1 ||
              row.market.length > 1 ||
              row.selection.length > 1) && (
              <span
                className="bets-report-expand-icon"
                onClick={() => {
                  setExpandedRows((prev) => {
                    if (prev.includes(row.customId)) {
                      return prev.filter((index) => index !== row.customId);
                    }
                    return [...prev, row.customId];
                  });
                }}
              >
                {expandedRows.includes(row.customId) ? "-" : "+"}
              </span>
            )}
          </div>
          <span className="bets-report-sportsbook-item">{value}</span>
        </div>
      </td>
    ),
    userId: (value, row, col, rowIndex) => (
      <td key={col.key + rowIndex} style={{ width: col.initialWidth }}>
        <Popover content={popoverContent(row)} placement="topLeft">
          <span
            className="bets-report-sportsbook-item bets-report-user-id-item"
            onClick={() => handleViewUserClicked(row)}
          >
            {value}
          </span>
        </Popover>
      </td>
    ),
    id: (value, row, col, rowIndex) => (
      <td key={col.key + rowIndex} style={{ width: col.initialWidth }}
      onClick={() => copyToClipboard(row)}>
          <span
            className="bets-report-sportsbook-item bets-report-bet-id-item"
          >
            {value}
          </span>
      </td>
    ),
    sport: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth, textTransform: "capitalize" }}
      >
        <div className="bets-report-sportsbook-container">
          {value.map((item, index) => (
            <span
              key={item + rowIndex}
              className={`bets-report-sportsbook-item ${
                index > 0 ? "bets-report-sportsbook-sub-item" : ""
              }${expandedRows.includes(row.customId) ? " expanded" : ""}`}
            >
              {item}
            </span>
          ))}
        </div>
      </td>
    ),
    league: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth, textTransform: "capitalize" }}
      >
        <div className="bets-report-sportsbook-container">
          {value.map((item, index) => (
            <span
              key={item + index}
              className={`bets-report-sportsbook-item ${
                index > 0 ? "bets-report-sportsbook-sub-item" : ""
              }${expandedRows.includes(row.customId) ? " expanded" : ""}`}
            >
              {item}
            </span>
          ))}
        </div>
      </td>
    ),
    market: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth, textTransform: "capitalize" }}
      >
        <div className="bets-report-sportsbook-container">
          {value.map((item, index) => (
            <span
              key={item + index}
              className={`bets-report-sportsbook-item ${
                index > 0 ? "bets-report-sportsbook-sub-item" : ""
              }${expandedRows.includes(row.customId) ? " expanded" : ""}`}
            >
              {item}
            </span>
          ))}
        </div>
      </td>
    ),
    selection: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth, textTransform: "capitalize" }}
      >
        <div className="bets-report-sportsbook-container">
          {value.map((item, index) => (
            <span
              key={item + index}
              className={`bets-report-sportsbook-item ${
                index > 0 ? "bets-report-sportsbook-sub-item" : ""
              }${expandedRows.includes(row.customId) ? " expanded" : ""}`}
            >
              {item}
            </span>
          ))}
        </div>
      </td>
    ),
    ccf: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth }}
        className={`ccf-text-container ${
          value === "Not Show" ? "" : handleCCF(value)
        }`}
      >
        {value ? value : "-"}
      </td>
    ),
    preMatchLive: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth }}
        className="bets-report-pre-match-live-container"
      >
        <span
          className={`bets-report-pre-match-icon ${value.toLowerCase()}`}
        ></span>
      </td>
    ),
    odds: (value, row, col, rowIndex) => (
      <td key={col.key + rowIndex} style={{ width: col.initialWidth }}>
        {value > 0 ? `+${value}` : value}
      </td>
    ),
    wagerAmount: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth }}
        className="bets-report-bet-amount-container"
      >
        <div className="bets-report-bet-amount-container-inner">
          {row.money_type === appConfig?.app_currency_config?.primary_currency?.shortcode ? (
            <img src={cashIcon} alt="Cash" />
          ) : row.money_type === "rebet_free_cash" ? (
            <img src={freeCashIcon} alt="Free Cash" />
            ) : row.money_type === appConfig?.app_currency_config?.secondary_currency?.shortcode ? (
            <img src={coinIcon} alt="Coin" />
          ) : (
            ""
          )}
          {Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value)}
        </div>
      </td>
    ),
    payout: (value, row, col, rowIndex) => (
      <td
        key={col.key + rowIndex}
        style={{ width: col.initialWidth }}
        className="bets-report-bet-amount-container"
      >
        <div className="bets-report-bet-amount-container-inner">
          {row.money_type === appConfig?.app_currency_config?.primary_currency?.shortcode ? (
            <img src={cashIcon} alt="Cash" />
          ) : row.money_type === "rebet_free_cash" ? (
            <img src={freeCashIcon} alt="Free Cash" />
            ) : row.money_type === appConfig?.app_currency_config?.secondary_currency?.shortcode ? (
            <img src={coinIcon} alt="Coin" />
          ) : (
            ""
          )}
          {Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value)}
        </div>
      </td>
    ),
  };

  useEffect(() => {
    const table = tableRef.current;

    if (!table) return;

    Sortable.create(table.querySelector("tbody"), {
      animation: 150,
    });
  }, []);

  function removeResizer() {
    const table = tableRef.current;
    if (!table) return;
    const resizers = table.querySelectorAll(".resizer");
    resizers.forEach((resizer) => {
      resizer.remove();
    });
  }

  useEffect(() => {
    if (mode !== "drag") return;

    removeResizer();

    
    const sortable = Sortable.create(theadRef.current, {
      animation: 150,
      onEnd: (evt) => {
        const savedColumnsState = JSON.parse(localStorage.getItem("columnsState")) || columnsState;
        const newOrder = [...savedColumnsState];
        const [moved] = newOrder.splice(evt.oldIndex, 1);
        
        newOrder.splice(evt.newIndex, 0, moved);
        localStorage.setItem("columnsState", JSON.stringify(newOrder));
        
        setColumnsState(newOrder);
      },
    });

    return () => {
      sortable.destroy();
    };
  }, [mode, columnsState]);

  useEffect(() => {
    if (mode !== "resize") return;

    const table = tableRef.current;
    const ths = table.querySelectorAll("th");

    ths.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.classList.add("resizer");
      resizer.style.height = `${table.offsetHeight}px`;
      col.appendChild(resizer);
      makeResizable(col, resizer);
    });

    const saveColumnWidth = (col, width) => {
      const colName = col.textContent;
      console.log("colName", colName, width);
      const savedColumnsState = JSON.parse(localStorage.getItem("columnsState")) || columnsState;
      const newColumnsState = savedColumnsState.map((col) => {
        if (col.title === colName) {
          return { ...col, initialWidth: width };
        }
        return col;
      });
      console.log("newColumnsState", newColumnsState);
      localStorage.setItem("columnsState", JSON.stringify(newColumnsState));
    };

    function makeResizable(col, resizer) {
      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        const styles = window.getComputedStyle(col);
        w = parseInt(styles.width, 10);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        resizer.classList.add("resizing");
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };
      
      const onMouseUp = () => {
        saveColumnWidth(col, col.style.width);
        resizer.classList.remove("resizing");
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    }
  }, [mode]);

  return (
    <div>
      <div className="drag-and-drop-table-container">
        <table ref={tableRef} className="table">
          <thead>
            <tr ref={theadRef}>
              {columnsState.map((col) => (
                <th
                  key={col.key}
                  style={{
                    width: col.initialWidth,
                    cursor: mode === "drag" ? "grab" : "default",
                  }}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index} className={row.status === "Rejected" ? "rejected-row" : ""}>
                {columnsState.map((col) => {
                  const value = row[col.key];
                  const renderFn = renderMap[col.key];

                  if (renderFn) {
                    return renderFn(value, row, col, index);
                  }

                  return (
                    <td
                      key={col.key + index}
                      style={{ width: col.initialWidth }}
                    >
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        {data.length === 0 && (
          <div className="drag-and-drop-table-empty-container">
            <Empty />
          </div>
        )}
      </div>
    </div>
  );
};

export default DragAndDropTable;
